import portfolio1 from '../../assets/portfolio-1.png'
import portfolio2 from '../../assets/portfolio-2.png'
import portfolio4 from '../../assets/portfolio-4.png'
import portfolio5 from '../../assets/portfolio-5.png'
import portfolio6 from '../../assets/portfolio-6.png'
import portfolio7 from '../../assets/portfolio-7.png'
import portfolio8 from '../../assets/portfolio-8.png'


export const worksData = [
    {
        image: portfolio1,
        title: "Website Development for Higher Education Institution",
        des: "The vision is to build college website by the students for the students.",
        demolink: "https://github.com/Mohanpavankumar/BecCollegeWebsite"
    },
    {
        image: portfolio2,
        title: "Heart Disease Prediction",
        des: "It display whether the user having heart disease or not based on different algoritms and overall prediction.",
        demolink: "https://github.com/Mohanpavankumar/HeartDiseasePrediction.git"
    },
    {
        image: portfolio4,
        title: "Mern Authentication System",
        des: "This project is a MERN stack application that provides user authentication features, including login, signup, and forgot password.",
        demolink: "https://mern-authenticationsystem.netlify.app/"
    },
    {
        image: portfolio5,
        title: "Sudoku Validator",
        des: "It evaluates the Sudoku Puzzles that, whether the Puzzle is valid or NotValid.",
        demolink: "https://github.com/Mohanpavankumar/SudokuValidator.git"
    },
    {
        image: portfolio6,
        title: "Quiz App",
        des: "QuizApp is a simple and interactive web-based quiz application built with HTML, CSS, and JavaScript.",
        demolink: "https://brain-buster-quizapp.netlify.app/"
    },
    {
        image: portfolio7,
        title: "Tenzies",
        des: "A fun and interactive dice game built using React! The goal is to roll until all dice show the same value. You can hold dice between rolls to lock their value.",
        demolink: "https://tenzies-capstone.netlify.app/"
    },
    {
        image: portfolio8,
        title: "Essembly Endgame",
        des: "A fun word-guessing game where you must guess the programming word before the world falls back into Assembly, Built using React.",
        demolink: "https://essembly-endgame.netlify.app/"
    },
]